import type { ComponentProps } from "react";

export const Close = ({
	color = "#0E0E0E",
	...rest
}: ComponentProps<"svg"> & { color?: string }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}
		>
			<path d="M16 8L8 16M16 16L8 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
		</svg>
	);
};
